module.exports = __webpack_public_path__ + "static/media/preview_attempts.8403e985.svg";